import {
	Component,
	Element,
	ComponentInterface,
	h,
	Host,
	Prop,
	Method,
} from '@stencil/core';

@Component({
	tag: 'ds-video-transcript',
})
export class VideoTranscript implements ComponentInterface {
	@Element() el: HTMLDsVideoTranscriptElement;

	@Prop({ attribute: 'component-id' }) componentId: string;

	dataLinkEventValue: string;

	expanded = false;

	componentDidLoad(): void {
		this.handleDataLinkEventValue();
		this.setContentIsFocusable();
		document.addEventListener('click', this.handleClickOutSide);
	}

	@Method()
	async updateText(text: string) {
		const textEl = this.el.querySelector('.ds-transcript-content-padding');
		if (textEl) {
			textEl.innerHTML = text;
		}
	}

	handleClickOutSide = (e: MouseEvent): void => {
		if (this.expanded === true) {
			this.handleClick(e);
		}
	};

	handleKeyDown = async (event: KeyboardEvent): Promise<void> => {
		if (
			event.key === 'Enter' ||
			event.key === 'Space' ||
			event.code === 'Space'
		) {
			this.handleOpenClose('keyboard');
		}
	};

	handleClick = (e: MouseEvent): void => {
		e.preventDefault();
		e.stopPropagation();

		if (
			!(e.target as HTMLElement).classList.contains(
				'ds-transcript-content-padding'
			) &&
			!(e.target as HTMLElement).parentElement.classList.contains(
				'ds-transcript-content-padding'
			)
		) {
			this.handleOpenClose('mouse');
		}
	};

	handleOpenClose = (eventType: 'keyboard' | 'mouse'): void => {
		this.searchForUncheckedInput().checked = true;
		this.expanded = !this.expanded;
		eventType === 'keyboard' && this.reFocusAfterKeyDown();
		this.handleDataLinkEventValue();
		this.setContentIsFocusable();
	};

	searchForUncheckedInput = (): HTMLInputElement =>
		Array.from(this.el.querySelectorAll('input[type="radio"]')).filter(
			(radioEl: HTMLInputElement) => radioEl.checked !== true
		)[0] as HTMLInputElement;

	handleDataLinkEventValue = (): void => {
		this.el.setAttribute(
			'data-link-event',
			`${this.componentId}:transcript:cta:${this.expanded ? 'open' : 'close'}`
		);
	};

	reFocusAfterKeyDown = (): void => {
		this.el.focus();
	};

	setContentIsFocusable() {
		const content = this.el.querySelector('.ds-transcript-content');
		if (content) {
			content.setAttribute('tabindex', this.expanded ? '0' : '-1');
		}
	}

	render() {
		return (
			<Host onClick={this.handleClick} onKeyDown={this.handleKeyDown}>
				<slot />
			</Host>
		);
	}
}
